function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import Icon from "../../../Display/Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EditField = _ref => {
  let {
    FieldComponent,
    fieldMeta,
    fieldProps,
    id,
    isSaving,
    label,
    onBlur,
    onCancelEdit,
    onChange,
    onSaveEdit,
    setFieldRef,
    value,
    afterLabelContent = null
  } = _ref;
  const controlsClass = () => cn({
    'flex w-10': true,
    'opacity-50': isSaving
  });
  const labelWIthControls = () => /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex my-1 justify-between",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex-auto capitalize text-text-blue text-sm font-heavy-font tracking-normal leading-4",
          children: label
        }), fieldProps.required && /*#__PURE__*/_jsx("span", {
          className: "inline-block text-red text-sm ml-1 transform -translate-y-1 align-text-top",
          children: "*"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: controlsClass(),
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "Cross",
          className: "bg-red rounded-full p-1 box-border",
          onClick: onCancelEdit,
          id: "".concat(id, "-cancel-btn"),
          color: "white",
          ariaLabel: "Cancel",
          size: 18,
          disabled: isSaving
        }), /*#__PURE__*/_jsx(Icon, {
          icon: "Check",
          className: "bg-green rounded-full p-1 ml-1 box-border",
          onClick: onSaveEdit,
          id: "".concat(id, "-save-btn"),
          color: "white",
          ariaLabel: "Save",
          size: 18,
          disabled: isSaving
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: afterLabelContent
    })]
  });
  return /*#__PURE__*/_jsx(FieldComponent, _objectSpread(_objectSpread(_objectSpread({
    ref: setFieldRef,
    id: "".concat(id, "-field"),
    label: labelWIthControls(),
    value: value,
    onChange: onChange,
    onBlur: onBlur
  }, fieldProps), fieldMeta), {}, {
    omitLabelStyles: true,
    omitRequiredLabel: true
  }));
};
EditField.propTypes = {
  afterLabelContent: PropTypes.node,
  FieldComponent: PropTypes.func.isRequired,
  fieldMeta: PropTypes.object.isRequired,
  fieldProps: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  isSaving: PropTypes.bool.isRequired,
  label: PropTypes.any.isRequired,
  onBlur: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSaveEdit: PropTypes.func.isRequired,
  setFieldRef: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired
};
export default EditField;
//# sourceMappingURL=EditField.js.map